module.exports = __webpack_public_path__ + "app-static/img/10.8d647341.jpg";